// Deutsches Referenz-Wörterbuch der Landing — definiert den `Dict`-Typ.
// Neue Sprache = diese Datei kopieren, übersetzen, in i18n/index.ts registrieren.

export const de = {
  meta: {
    title: "Pulpo: Die digitale Speisekarte für dein Restaurant",
    description:
      "Gäste scannen den QR-Code am Tisch und sehen deine Speisekarte auf dem Handy: in ihrer Sprache, mit Fotos und aktuellen Preisen.",
  },
  nav: { login: "Anmelden" },
  hero: {
    eyebrow: "Die digitale Speisekarte für dein Restaurant",
    title: "Deine Karte. Jede Sprache. Immer aktuell.",
    sub: "Gäste scannen den QR-Code am Tisch und sehen deine Speisekarte auf dem Handy: in ihrer Sprache, mit Fotos und aktuellen Preisen. Du pflegst alles an einem Ort.",
    ctaStart: "Kostenlos starten",
    ctaDemo: "Beispielkarte ansehen",
  },
  steps: {
    title: "So funktioniert's",
    items: [
      {
        title: "Registrieren und Gerichte eintragen",
        body: "Kategorien, Preise, Fotos. Direkt im Browser, ohne Installation.",
      },
      {
        title: "QR-Code auf den Tisch",
        body: "Code ausdrucken, fertig. Deine Gäste brauchen keine App.",
      },
      {
        title: "Ändern, wenn sich etwas ändert",
        body: "Neuer Preis, neues Tagesgericht: in Sekunden online, ohne Neudruck.",
      },
    ],
  },
  included: {
    title: "Alles drin",
    hint: "Was deine Karte kann, ohne Aufpreis.",
    price: "inklusive",
    items: [
      {
        name: "Karte in mehreren Sprachen",
        note: "mit automatischer Übersetzung für deine Gäste aus aller Welt",
      },
      {
        name: "Fotos, Allergene und Kennzeichnungen",
        note: "jedes Gericht mit Bild und sauberer Deklaration",
      },
      {
        name: "Preise in Sekunden ändern",
        note: "keine Druckerei, kein Überkleben",
      },
      {
        name: "QR-Code zum Ausdrucken",
        note: "für Tisch, Aushang oder Flyer",
      },
      {
        name: "Eigene Webseite und Domain",
        note: "deine Karte wohnt unter deinem Namen",
      },
      {
        name: "Keine App für Gäste",
        note: "scannen, lesen, bestellen wie immer",
      },
    ],
  },
  pricing: {
    title: "Die Rechnung, bitte",
    hint: "Die digitale Speisekarte ist kostenlos.",
    lines: [
      { name: "Digitale Speisekarte", price: "0 €" },
      { name: "Standard-Webseite mit Karte und Kontakt", price: "0 €" },
      { name: "Eigene Domain verbinden", price: "0 €" },
      { name: "Werbung", price: "keine" },
    ],
    totalLabel: "Gesamt pro Monat",
    total: "0 €",
    note: "Restaurant anlegen, und deine Karte ist online. Vielen Dank für deinen Besuch!",
    extrasTitle: "Auf Wunsch dazu",
    extras: [
      { name: "Support per Chat und E-Mail", price: "9 € / Monat" },
      { name: "Individuelle Webseite, von uns gestaltet", price: "einmalig ab 490 €" },
    ],
  },
  finale: {
    title: "Heute Abend schon online?",
    sub: "Restaurant anlegen, Gerichte eintragen, und deine Karte ist sofort unter deiner eigenen Adresse erreichbar.",
    cta: "Kostenlos starten",
  },
  phone: {
    restaurant: "Casa Pulpo",
    menuTitle: "Speisekarte",
    category: "Empfehlungen",
    dishes: [
      { name: "Tagessuppe", price: "6,50 €" },
      { name: "Oktopus vom Grill", price: "18,90 €" },
      { name: "Schokoladenkuchen", price: "7,20 €" },
    ],
  },
};

export type Dict = typeof de;
